import React, { push, Component } from "react";
import {
  Grommet,
  Box,
  Header,
  Button,
  Layer,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  Card,
  CardHeader,
  CardBody,
  List,
  Grid,
  TextInput,
  Select,
  RadioButtonGroup,
  Form,
  CheckBox,
  DateInput,
  FormField,
  CheckBoxGroup,
  Tabs,
  Tab,
  Image,
  CardFooter,
  IFrame,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Notification,
  Console,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  CaretDownFill,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Filter,
  Video,
  DocumentPdf,
  Inspect,
  Close,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";

class GetHelpL5 extends Component {
  // const { push } = React.useContext(RouterContext)
  constructor(props) {
    super(props);
  }
  componentDidMount() {}

  render() {
    return (
      <Layer
        full={true}
        position="center"
        height="medium"
        onClickOutside={this.props.hide}
        onEsc={this.props.hide}
      >
        <Box fill="vertical" align="stretch" justify="start">
          <Main
            overflow="auto"
            background={{ image: "url('')" }}
            flex
            align="stretch"
            justify="start"
          >
            <Box
              align="stretch"
              justify="center"
              flex="grow"
              background={{ color: "background-back" }}
              direction="row"
            >
              <Box
                align="stretch"
                justify="start"
                flex="shrink"
                pad={{ horizontal: "large", vertical: "medium" }}
                basis="xlarge"
                direction="column"
                gap="medium"
              >
                <Box align="center" justify="end" direction="row">
                  <Button
                    icon={<Close />}
                    onClick={this.props.hide}
                    secondary
                  />
                </Box>
                <Header
                  align="start"
                  direction="column"
                  flex={false}
                  justify="start"
                  gap="xxsmall"
                >
                  <Heading margin="none">
                    Get Help - Issues when using Linux or Apple devices
                  </Heading>
                </Header>
                <Box
                  align="stretch"
                  justify="center"
                  pad="medium"
                  gap="large"
                  direction="column"
                >
                  <Card hoverIndicator>
                    <CardHeader
                      align="start"
                      direction="column"
                      justify="start"
                      flex={false}
                    >
                      <Box align="center" justify="center" direction="row">
                        <Heading size="small" level="4">
                          The Issue:
                        </Heading>
                      </Box>
                      <Box align="center" justify="center" direction="row">
                        <Grid
                          columns={{ size: "small", count: "fit" }}
                          rows="small"
                        >
                          <Paragraph size="medium">
                            Issues when launching a demonstration via Citrix
                            using Linux or Apple laptops/devices
                          </Paragraph>
                          <Image
                            src="/img/GetHelp/GHL5-DE2.png
"
                            fit="contain"
                            fill
                          />
                        </Grid>
                      </Box>
                    </CardHeader>
                    <CardBody
                      direction="column"
                      justify="start"
                      align="stretch"
                    >
                      <Heading size="small" level="4">
                        Citrix receiver not functioning well on Linux
                      </Heading>
                      <Text>
                        Run the following commands and it should resolve the
                        issue
                      </Text>
                      <Text>
                        sudo ln -s /usr/share/ca-certificates/mozilla/*
                        /opt/Citrix/ICAClient/keystore/cacerts/
                      </Text>
                      <Text>
                        sudo c_rehash /opt/Citrix/ICAClient/keystore/cacerts/
                      </Text>
                      <Heading size="small" level="4">
                        Citrix receiver not functioning well on Mac
                      </Heading>
                      <Paragraph size="medium" textAlign="start" fill>
                        When using a Mac you must use the light version which
                        launches through HTML. If you are on the Storefront page
                        where your VM can't launch Click on your Name in the top
                        right corner and click on "Change Receiver" Now click on
                        Use light Version
                      </Paragraph>
                      <Image
                        src="/img/GetHelp/GHL2-CitrixReceiver.png
"
                        fit="contain"
                      />
                    </CardBody>
                    <CardFooter
                      align="center"
                      direction="row"
                      flex={false}
                      justify="between"
                      gap="medium"
                      pad="small"
                    >
                      <Text size="xsmall">#GH-L5</Text>
                    </CardFooter>
                  </Card>
                </Box>
              </Box>
            </Box>
          </Main>
        </Box>
      </Layer>
    );
  }
}

export default GetHelpL5;
